export default "__VITE_ASSET__DDn5XbDe__"